import { createAction, props } from "@ngrx/store";

export const FETCH_SOURCE_STATS_LIST = createAction(
    'FETCHSOURCEstatsLIST',
    props<{ sourceStats: any }>()
);